"use strict";

require("core-js/modules/es.array.reduce");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.detectPackage = detectPackage;

var _assert = require("./assert");

var _string = require("./is/string"); // Copyright 2017-2020 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0


function expandPath(path) {
  return !path || path.length < 5 ? '<unknown>' : path;
}
/** @internal */


function flattenVersions(_all) {
  var all = _all.map(function (version) {
    return (0, _string.isString)(version) ? {
      version: version
    } : version;
  });

  var verLength = all.reduce(function (max, _ref) {
    var version = _ref.version;
    return Math.max(max, version.length);
  }, 0);
  return all.map(function (_ref2) {
    var path = _ref2.path,
        version = _ref2.version;
    return "\t".concat(version.padEnd(verLength), "\t").concat(expandPath(path));
  }).join('\n');
}
/**
 * @name detectPackage
 * @summary Checks that a specific package is only imported once
 */


function detectPackage(_ref3, path) {
  var name = _ref3.name,
      version = _ref3.version;

  var _global = typeof window !== 'undefined' ? window : global;

  if (!_global.__polkadotjs) {
    _global.__polkadotjs = {};
  }

  (0, _assert.assert)(name.startsWith('@polkadot'), "Invalid package descriptor ".concat(name));
  _global.__polkadotjs[name] = [].concat(_toConsumableArray(_global.__polkadotjs[name] || []), [{
    path: path || '',
    version: version
  }]);

  if (_global.__polkadotjs[name].length !== 1) {
    var versions = flattenVersions(_global.__polkadotjs[name]);
    console.warn("Multiple instances of ".concat(name, " detected, ensure that there is only one package in your dependency tree.\n").concat(versions));
  }
}